/**
 * «Pro · trial» on a dashboard tab that only the Pro trial opens (#2816) — in
 * the lock's place, in both tab strips: the dashboard's own and the Bitrix24
 * host's (`TabNavigation`). Nothing for a tab without a plan floor, a locked
 * tab, or outside the trial (`useTrialOpened`).
 */
import { useTranslation } from 'react-i18next';
import { useTrialOpened } from '@/hooks/useTrialOpened';
import { PRO_TRIAL_PLAN } from '@/lib/pro-trial';
import { UNIFIED_LAYOUT } from './layout';
import type { UnifiedSection } from './unified-search';

export function TrialTabMark({ section }: { section: UnifiedSection }) {
  const { t } = useTranslation('common');
  const trialOpened = useTrialOpened();
  const flag = UNIFIED_LAYOUT[section].tierFlag;
  if (!flag || !trialOpened(flag)) return null;
  return (
    <span data-testid="unified-tab-trial" className="ml-1 text-xs text-info-fg">
      {t('proTrial.label', { plan: PRO_TRIAL_PLAN })}
    </span>
  );
}
